<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre3"><span id="pgepubid00003" title="[v]"><a class="reference" id="Page_v"></a></span></p>
<h2 class="nobreak" id="PREFACE">PREFACE</h2>
</div>
<p class="calibre3">The year after Mr. Emerson’s death, Mr.
Cabot, in editing his works, gathered into
a volume the occasional writings which had
never been included in previous editions, although
six of them had been printed, either as
pamphlets or in periodicals, long before, by the
author. These were the Sermon on The Lord’s
Supper, the Historical Address at Concord in
1835, that at the dedication of the Soldiers’
Monument there in 1867, and that on Emancipation
in the British West Indies, the Essay
on War, and the Editors’ Address in the
<i class="calibre9">Massachusetts Quarterly Review</i>. “American
Civilization” had been a portion of the article
of that name in the <i class="calibre9">Atlantic</i> in 1862. “The
Fortune of the Republic” also had been printed
as a pamphlet in 1874. Mr. Cabot said in his
prefatory note, “In none was any change from
the original form made by me, except in the
‘Fortune of the Republic,’ which was made up
of several lectures, for the occasion upon which
it was read.” This was after Mr. Emerson was<span id="pgepubid00004" title="[vi]"><a class="reference" id="Page_vi"></a></span>
no longer able to arrange his work and his
friends had come to his aid.</p>
<p class="calibre3">The speeches at the John Brown, the Walter
Scott, and the Free Religious Association
meetings had been printed, probably with Mr.
Emerson’s consent. The other pieces included
by Mr. Cabot, namely, the speeches on Theodore
Parker, the Emancipation Proclamation,
Abraham Lincoln, at the Harvard Commemoration,
“Woman,” the addresses to Kossuth,
and at the Burns Festival, had not been published.</p>
<p class="calibre3">All that were in Mr. Cabot’s collection will be
found here, although the order has been slightly
changed. To these I have added Mr. Emerson’s
letter to President Van Buren in 1838, his
speech on the Fugitive Slave Law in Concord
soon after its enactment, that on Shakspeare
to the Saturday Club, and his remarks at the
Humboldt Centennial, and at the dinner to the
Chinese Embassy; also the addresses at the consecration
of Sleepy Hollow Cemetery and at the
opening of the Concord Free Public Library.
The oration before the New England Society
of New York in 1870, printed by them in their
recent volume, is not included, as most of the<span id="pgepubid00005" title="[vii]"><a class="reference" id="Page_vii"></a></span>
matter may be found in the Historical Discourse
at Concord and in the essay “Boston,” in
<i class="calibre9">Natural History of Intellect</i>.</p>
<p class="calibre3">I have given to the chapters mottoes, the
most of them drawn from Mr. Emerson’s
writings.</p>
<p class="right">EDWARD W. EMERSON.</p>
<p class="calibre3"><span id="pgepubid00006" title="[viii]"><a class="reference" id="Page_viii"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?47e78ae6